<div>
    <div class="actions">
        <button (click)="addVehicle()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Add Vehicle'">
            <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
            Add Vehicle
        </button>
        <button (click)="openBulkUploadDialog()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Bulk Upload'">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            Bulk Upload
        </button>
        <button
                type="button"
                class="btn-icon-action"
                (click)="downloadTemplate()"
                [disabled]="role === 'Member'"
                title="Download Template">
            <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
        </button>
    </div>

    <app-bulk-import-result
            *ngIf="bulkImportResult"
            [totalImported]="bulkImportResult.totalImported"
            [totalFailed]="bulkImportResult.totalFailed"
            [errors]="bulkImportResult.errors"
            [failedRowsCsvBase64]="bulkImportResult.failedRowsCsvBase64"
            [failedRowsFilename]="bulkImportResult.failedRowsFilename">
    </app-bulk-import-result>

    <div class="container-table">
        <div class="top-header">
            <h3>Vehicle Monitoring</h3>
            <p>Vehicle Monitoring Records As On {{ todayDate | date: 'dd-MM-yyyy' }}</p>
        </div>
        <div>
            <div class="tab-head">
                <div class="search-bar wide-search-bar">
                    <app-generic-search
                            [apiUrl]="'vehicle-alert-rules/search_suggestion'"
                            [resultsApiUrl]="'vehicle-monitoring/'"
                            [method]="'GET'"
                            [searchParamName]="'q'"
                            [pageSize]="10"
                            [minChars]="2"
                            [extraBody]="searchExtraBody"
                            (resultsFetched)="onResults($event)">
                    </app-generic-search>
                </div>
                <div class="filters table-filters">
                    <div class="filter">
                        <label>Monitoring Type</label>
                        <app-monitoring-type-multiselect
                                [selectedValues]="selectedAlertTypes"
                                (selectionApplied)="applyAlertTypeFilter($event)">
                        </app-monitoring-type-multiselect>
                    </div>
                    <div class="filter">
                        <label>Severity</label>
                        <app-monitoring-type-multiselect
                                [selectedValues]="selectedSeverities"
                                [options]="severityFilterOptions"
                                [orderedValues]="severityFilterOrder"
                                allSelectedLabel="All Severities"
                                (selectionApplied)="applySeverityFilter($event)">
                        </app-monitoring-type-multiselect>
                    </div>
                </div>
                <button (click)="exportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                </button>
            </div>
            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Vehicle Number</th>
                        <th>Monitoring Types</th>
                        <th>Severity</th>
                        <th>Remarks</th>
                        <th>Created By</th>
                        <th>Created On</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="vehicles.length === 0">
                        <td colspan="8" class="empty-state">No monitored vehicles found.</td>
                    </tr>
                    <tr *ngFor="let record of vehicles; let i = index">
                        <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                        <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                        <td>
                            <div class="monitoring-type-badges">
                                <app-monitoring-type-badge
                                        *ngFor="let rule of record.monitoring_rules"
                                        [monitoringType]="rule.type"
                                        [displayLabel]="rule.type_display">
                                </app-monitoring-type-badge>
                            </div>
                        </td>
                        <td>
                            <app-severity-badge
                                    [severity]="record.highest_severity"
                                    [displayLabel]="record.highest_severity_display">
                            </app-severity-badge>
                        </td>
                        <td>
                            <div class="content-tooltip-container">
                                <div class="text-clip"
                                     (mouseenter)="hoverRowKey=record.vehicle_number"
                                     (mouseleave)="hoverRowKey=null">
                                    {{ record.remarks || '-' }}
                                </div>
                                <div class="content-tooltip"
                                     *ngIf="hoverRowKey === record.vehicle_number && record.remarks && record.remarks !== 'Multiple' && record.remarks.length > 30">
                                    {{ record.remarks }}
                                </div>
                            </div>
                        </td>
                        <td>{{ record.created_by }}</td>
                        <td>{{ record.created_on | date: 'dd-MM-yyyy hh:mm a' }}</td>
                        <td class="table-actions-cell">
                            <span class="table-actions">
                                <button type="button" class="action-button bt-edit" (click)="editVehicle(record.id)"
                                        [disabled]="role === 'Member'"
                                        [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Edit'">
                                    <span>
                                        <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                                    </span>
                                </button>
                                <button type="button" class="action-button bt-delete" (click)="openDeleteDialog(record)"
                                        [disabled]="role === 'Member'"
                                        [title]="role === 'Member' ? 'You are not authorized to perform this action.' : 'Remove'">
                                    <span>
                                        <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                                    </span>
                                </button>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="footer">
                    <div class="footer-summary">
                        <div class="total-records">Grouped Vehicles: {{ totalRecords }}</div>
                        <div class="total-records">Total Monitoring Rules: {{ totalMonitoringRules }}</div>
                        <p class="table-helper-text">Each vehicle may contain multiple monitoring rules.</p>
                    </div>
                    <div class="pagination-controls">
                        <label for="recordsPerPage">Records per page </label>
                        <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
                            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
                        </select>
                        <span>{{ currentPage }} / {{ totalPages }}</span>
                        <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
                            <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
                        </button>
                        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
                            <fa-icon [icon]="['fas', 'angle-right']" class="fa-light"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showBulkUploadDialog" class="confirmation-modal">
    <div class="modal-content bulk-upload-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3>Bulk Upload</h3>
        </div>
        <div class="modal-body bulk-upload-body">
            <p class="bulk-upload-intro">Upload a CSV or Excel file to add multiple vehicles to monitoring.</p>
            <div class="bulk-upload-file-row">
                <button type="button" class="btn-action" (click)="bulkUploadFileInput.click()" [disabled]="uploadingBulk">
                    <fa-icon [icon]="['fas', 'upload']"></fa-icon>
                    Choose File
                </button>
                <span class="bulk-upload-file-name">{{ bulkUploadFile?.name || 'No file selected' }}</span>
                <input #bulkUploadFileInput type="file" accept=".csv,.xlsx" (change)="onBulkFileSelected($event)" hidden/>
            </div>
            <app-bulk-upload-supported-values
                    [fields]="bulkUploadSupportedFields"
                    [tip]="bulkUploadSupportedTip">
            </app-bulk-upload-supported-values>
        </div>
        <div class="button-row">
            <button type="button" class="btn-cancel" (click)="closeBulkUploadDialog()" [disabled]="uploadingBulk">
                <fa-icon [icon]="['fas', 'square-xmark']"></fa-icon>
                Cancel
            </button>
            <button type="button" class="btn-action" (click)="submitBulkUpload()"
                    [disabled]="!bulkUploadFile || uploadingBulk">
                <fa-icon [icon]="['fas', 'upload']"></fa-icon>
                {{ uploadingBulk ? 'Uploading...' : 'Upload' }}
            </button>
        </div>
    </div>
</div>

<div *ngIf="showDeleteDialog && selectedVehicle" class="confirmation-modal delete-monitoring-modal">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <i class="bi bi-exclamation-triangle warning-icon"></i>
            <h3>Delete Vehicle Monitoring</h3>
        </div>
        <div class="modal-body delete-monitoring-body">
            <p><strong>Vehicle:</strong> {{ selectedVehicle.vehicle_number }}</p>
            <p class="delete-monitoring-label">Monitoring Types</p>
            <label *ngFor="let rule of selectedVehicle.monitoring_rules" class="delete-monitoring-option">
                <input
                        type="checkbox"
                        [checked]="isRuleSelected(rule.id)"
                        (change)="toggleRuleSelection(rule.id, $any($event.target).checked)">
                <app-monitoring-type-badge
                        [monitoringType]="rule.type"
                        [displayLabel]="rule.type_display">
                </app-monitoring-type-badge>
            </label>
        </div>
        <div class="button-row">
            <button type="button" class="btn-cancel" (click)="closeDeleteDialog()" [disabled]="deleting">Cancel</button>
            <button type="button" class="btn-action modal-red" (click)="deleteSelectedRules()"
                    [disabled]="selectedRuleIds.size === 0 || deleting">
                {{ deleting ? 'Deleting...' : 'Delete Selected' }}
            </button>
        </div>
    </div>
</div>
